import { Transaction } from 'functions/src/types/firestore/Game/Collection/Item/Transaction';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { TransactionRowDescription } from './TransactionRowDescription';
import { TransactionRowIcon } from './TransactionRowIcon';
import { truncate } from 'src/util/truncate';

export type TransactionTableRowProps = {
  transaction: Transaction<Date>;
};

export function TransactionTableRow({ transaction }: TransactionTableRowProps) {
  const theme = useTheme();
  const { type, fromAddress, blockTimestamp } = transaction;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        '&:hover': {
          background: theme.palette.action.hover,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            mx: 3,
          }}
        >
          <TransactionRowIcon type={type} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
            p: 4,
          }}
        >
          <Typography>
            {truncate(fromAddress || transaction?.from?.address)}{' '}
          </Typography>
          <TransactionRowDescription transaction={transaction} />
        </Box>
      </Box>
      <Box sx={{ pr: 4 }}>
        <Typography sx={{ color: theme.palette.text.secondary }}>
          {blockTimestamp?.toLocaleDateString?.() ||
            new Date(blockTimestamp.seconds * 1000).toLocaleDateString()}
          {` at `}
          {blockTimestamp?.toLocaleTimeString()}
        </Typography>
      </Box>
    </Box>
  );
}
